<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>

    <v-dialog v-model="iosDialog">
      <v-card>
        <v-card-text>
          <v-icon
            @click="closeDialog"
            style="position:absolute; right:10px"
            class="black--text"
            large
          >mdi-close</v-icon>
          <div class="d-flex flex-column align-center justify-center">
            <div class="d-flex images mt-12">
              <!-- <img src="@/assets/ocpn_grey.svg" alt=""> -->
              <img class="ml-5" src="@/assets/ocpn_grey.svg" alt />
              <img class="mx-5" src="@/assets/dn2me_icon.svg" alt />
              <img class="mr-5" src="@/assets/ocpn_grey.svg" alt />
              <!-- <img src="@/assets/ocpn_grey.svg" alt=""> -->
            </div>
            <h2 class="font-weight-regular black--text text-center mt-10">Install DoctorNext2Me</h2>
            <p
              class="text-center mt-4"
              style="font-size:18px"
            >Install this application on your home screen for quick and easy access.</p>

            <div class="d-flex justify-center align-center mt-12">
              <p class="mb-0">1. Just tap</p>
              <img class="ml-2" src="@/assets/share.svg" alt />
            </div>

            <div class="d-flex justify-center align-center mt-2">
              <p class="mb-0">
                2. then
                <span class="font-weight-bold black--text">"Add to home Screen"</span>
              </p>
            </div>

            <v-checkbox
              class="mt-5"
              color="rgb(0,170,221)"
              v-model="dialog"
              label="Don't show this again"
            ></v-checkbox>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-bottom-sheet persistent v-model="sheet">
      <v-sheet class="text-center" height="200px">
        <div class="d-flex justify-center align-center pt-6">
          <v-btn text color="rgb(0,170,221)" @click="ask">Εντάξει</v-btn>
        </div>

        <div
          class="py-3"
        >Για την καλύτερη λειτουργία της εφαρμογής, θα σας ζητηθεί να αποδεχτείτε τις ειδοποιήσεις. Αυτό θα βοηθήσει να μην χάσετε καμία εισερχόμενη κλήση. <br> Αν δεν αποδεχτείτε, η εφαρμογή δεν θα μπορέσει να λειτουργήσει.</div>
      </v-sheet>
    </v-bottom-sheet>
  </v-app>
</template>

<script>
import axios from "axios";
import { Howl, Howler } from "howler";
import * as firebase from "firebase";
export default {
  name: "App",

  created() {
    this.$store.dispatch(
      "setSound",
      new Howl({
        src: ["sound.mp3"],
        volume: 1.0,
        loop: true
      })
    );

    const firebaseConfig = {
      apiKey: process.env.VUE_APP_apiKey,
      authDomain: process.env.VUE_APP_authDomain,
      databaseURL: process.env.VUE_APP_databaseURL,
      projectId: process.env.VUE_APP_projectId,
      storageBucket: process.env.VUE_APP_StorageBucket,
      messagingSenderId: process.env.VUE_APP_messagingSenderId,
      appId: process.env.VUE_APP_appId,
      measurementId: process.env.VUE_APP_measurementId
    };
    firebase.initializeApp(firebaseConfig);

    if (firebase.messaging.isSupported()) {
      const messaging = firebase.messaging();
      this.messaging = messaging;
      messaging.usePublicVapidKey(process.env.VUE_APP_publicVapidKey);

      if (localStorage.getItem("asked") !== true) {
        if (Notification.permission === "default") {
          this.sheet = true;
        }
      }

      // messaging
      //   .requestPermission()
      //   .then(() => {
      //     console.log("Notification permission granted.");

      //     // Get Token
      //     //if(!!localStorage.getItem('fcmToken')){
      //     // messaging.deleteToken(localStorage.getItem('fcmToken'))
      //     //   .then(() => {
      //     //     console.log('deleting token first')
      //     messaging.getToken().then(token => {
      //       console.log("fcm token", token);
      //       localStorage.setItem("fcmToken", token);
      //     });
      //     //  })
      //     //  }
      //   })
      //   .catch(err => {
      //     console.log("Unable to get permission to notify.", err);
      //   });

      messaging.onTokenRefresh(function() {
        messaging
          .getToken()
          .then(function(refreshedToken) {
            // console.log("Token gamw tin rereshed.", refreshedToken);
            // localStorage.setItem('fcmToken', refreshedToken)
            // Indicate that the new Instance ID token has not yet been sent to the
            // app server.
            //   setTokenSentToServer(false);
            // Send Instance ID token to app server.
            // sendTokenToServer(refreshedToken);
            // ...
          })
          .catch(function(err) {
            console.log("Unable to retrieve refreshed token ", err);
            //  showToken('Unable to retrieve refreshed token ', err);
          });
      });

      messaging.onMessage(payload => {
        console.log("Message received. ", payload);

        // store.dispatch('newIncidentIncoming',payload.data.emergencyId)
        //   .then(( )=>{

        new Notification(payload.notification.title);
        //   })
        //   .catch(err => {
        //     console.log(err)
        //   })

        // ...
      });
    }
  },

  data: () => ({
    dialog: false,
    sheet: false,
    messaging: null
  }),

  methods: {
    setUnavailable() {
      axios
        .post(`${process.env.VUE_APP_BASE_URL}/doctor/setCurrentAvailability`, {
          isCurrentlyAvailable: false
        })
        .then(res => {
          // commit('setCurrentAvailability', res.data)
          // commit('setLoading', false)
          // resolve(res)
        })
        .catch(err => {
          // commit('setLoading', false)
          // reject(err)
        });
    },
    ask() {
      localStorage.setItem("asked", true);
      this.sheet = !this.sheet;
      this.messaging
        .requestPermission()
        .then(() => {
          console.log("Notification permission granted.");

          // Get Token
          //if(!!localStorage.getItem('fcmToken')){
          // messaging.deleteToken(localStorage.getItem('fcmToken'))
          //   .then(() => {
          //     console.log('deleting token first')
          this.messaging.getToken().then(token => {
            console.log("fcm token", token);
            localStorage.setItem("fcmToken", token);
          });
          //  })
          //  }
        })
        .catch(err => {
          console.log("Unable to get permission to notify.", err);
        });
    },
    closeDialog() {
      this.$store.dispatch("closeDialog", this.dialog);
    }
  },
  computed: {
    iosDialog() {
      return this.$store.state.iosDialog;
    }
  }
};
</script>

<style lang="scss">
* {
  font-family: "Roboto" sans-serif;
}

h1,
h2,
h3,
h4,
h5 {
  font-weight: 400;
}

#local {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 30vw;
  height: 25vh;

  video {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover !important;
    border-radius: 10px !important;
  }
}

#remote {
  position: absolute;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgb(0, 170, 221);
  display: flex;
  justify-content: center;
  align-items: center;

  video {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover !important;
  }
}
</style>
